import { motion } from 'framer-motion'

import { ProductModal } from '@apps-common/apps/portal/pages/management/components/product'
import { ImageComponent } from '@apps-common/components/common'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IProductListModel } from '@apps-common/types/management/product'
import { formatPrice } from '@apps-common/utils/helpers'

interface IProps {
  product: IProductListModel
}
export const ProductListCard = ({ product }: IProps) => {
  const { productId, productName, imageUrl, productType, price, defaultItem } = product

  return (
    <motion.div variants={GRID_CARD_VARIANTS} className='w-full p-6 rounded-[35px] bg-surface text-text border border-border'>
      <div className='flex items-center justify-between w-full'>
        <div className='flex items-center justify-start gap-[5px]'>
          <div className='jost-light text-[0.9em]'>{productName}</div>
        </div>
        <div className='w-[40px] h-[40px] rounded-[25px] bg-surface-2 p-1 flex items-center justify-center'>
          <ImageComponent src={imageUrl} alt={productName} imageClasses='max-w-[25px]' errorIconClasses='text-[1.25em]' />
        </div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Type</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{productType?.toLowerCase()}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Default item:</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{defaultItem ? 'Yes' : 'No'}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Price:</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{formatPrice(price, 2)}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={ProductModal}
        disabled={false}
        componentProps={{
          productId
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
